import { Button, Col, Divider, Form, Input, Row, Select, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ViewType } from '../../../../components/fileView/FileType';
import { useFetchFileViewer } from '../../../../components/fileView/FileViewer';
import { IModuleInfo } from '../../../../redux/progress/module/moduleInterface';
import { IState } from '../../../../redux/store';
import RealTimeTitleBlock from '../RealTimeTitleBlock';


export interface RealTimeParamsPropies {
    module?: IModuleInfo;
}


function ModelParams(props: {
    line: (dataChange: any) => void,
    point: (dataChange: any) => void,
    status: boolean,
    tableBtn: boolean
}) {

    const [lineNum, setLineNum] = useState('')
    const [pointNum, setPointNum] = useState('')
    const confirm = () => {

        if (lineNum.split(',').length != 3) {
            message.error('线号格式不正确，请重新输入')
            return
        }
        if (pointNum.split(',').length != 3) {
            message.error('点号格式不正确，请重新输入')
            return
        }
        if (props.line)
            props.line(lineNum);
        if (props.point)
            props.point(pointNum);
    }
    return <>
        <div>
            <div style={{ marginTop: 20, marginLeft: 40 ,display: 'flex'}}>
                <span>线号：</span>
                <Tooltip placement="right" title='格式说明: [起始线号，终止线号，线号间隔]，如仅一条测线需要令线号间隔为0。'>
                    <Input style={{ width: 200 }} disabled={props.status || props.tableBtn} onChange={(e) => {
                        setLineNum(e.target.value)
                    }} />
                </Tooltip>



            </div>
            <div style={{ marginTop: 20, marginLeft: 40 }}>
                <span>点号：</span>
                <Tooltip placement="right" title=' 格式说明: [起始点号，终止点号，点号间隔]，如仅一条测线需要令点号间隔为0。'>
                    <Input style={{ width: 200 }} disabled={props.status || props.tableBtn} onChange={(e) => {
                        setPointNum(e.target.value)
                    }} />
                </Tooltip>

            </div>
            <Button style={{ marginTop: 20, marginLeft: 40 }} type='primary' onClick={confirm} disabled={props.status || props.tableBtn} size='large' >确认</Button>
        </div>


    </>
}

const mapStateToProps = (state: IState) => {
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
    };
};

export default connect(
    mapStateToProps
)(ModelParams);